@if (projectId$ | async; as projectId) { @if (facilityId$ | async; as facilityId) {
<a [routerLink]="['/project', projectId, 'facility', facilityId]"><button class="iconf-btn-blank minw150">close</button></a>
<ng-content></ng-content>
} }
